import * as React from "react"
import MouseHoverButtons from "../../common/mouseHoverButtons"
import { SDKContext } from "../../../context/SDKContext"
import { ChatStyles } from "./index"
import { useTranslation } from "react-i18next"
import ApproveUnapproveButton from "src/shared/components/ApproveUnapproveButton"
import { Button } from "@chakra-ui/react"
import { previewAttachmentId } from "src/recoil/atoms/chats"
import {  useSetRecoilState } from "recoil"
import { FaEye } from "react-icons/fa"

interface ChatHoverButtonsProps {
  isApproved?: boolean
  id: string
  parentReply?: string
  immediateParentChatId?: string
  hovered: boolean
  isModerator: boolean
  published: boolean
  toggleChat: (target: any, ref: any) => void
  positionX: string
  widthButton?: string
  heightHoverButton?: string
  isSmallIndex?: boolean
  alignButtons?: string
  styleschat: ChatStyles
  chatApprovalRequired: boolean
  hideUpproveButton?: boolean
  isAuthorModerator?: boolean
  hasAttachment?: boolean
}

const _ChatHoverButtons: React.FC<ChatHoverButtonsProps> = ({
  isApproved,
  id,
  immediateParentChatId,
  isModerator,
  isAuthorModerator,
  hovered,
  published,
  toggleChat,
  positionX,
  widthButton,
  isSmallIndex,
  heightHoverButton,
  alignButtons,
  styleschat,
  chatApprovalRequired,
  parentReply,
  hideUpproveButton,
  hasAttachment
}) => {
  const meetingClient = React.useContext(SDKContext)
  const toggleChatApprove = React.useCallback(
    isApproved => {
      meetingClient?.toggleChatApprove(
        isApproved,
        id,
        parentReply,
        immediateParentChatId
      )
    },
    [meetingClient, parentReply, id, immediateParentChatId]
  )

  const threeButtonsDisplayed =
    !hideUpproveButton &&
    (chatApprovalRequired === true || !isApproved) &&
    !isAuthorModerator &&
    isModerator &&
    hasAttachment &&
    !isAuthorModerator

  return (
    <MouseHoverButtons
      isPublished={published}
      isHovered={hovered && isModerator}
      isChat={true}
      positionX={positionX}
      toggleOverlay={toggleChat}
      displaySmall={threeButtonsDisplayed}
      additionalButtons={
        <>
          {isModerator && hasAttachment && (
            <ModPreviewButton
              id={id}
              styleschat={styleschat}
              widthButton={widthButton}
              displaySmall={threeButtonsDisplayed}
            />
          )}
          {!hideUpproveButton && (
            <ApproveUnapproveButton
              isApproved={isApproved}
              isAuthorModerator={isAuthorModerator}
              chatApprovalRequired={chatApprovalRequired}
              widthButton={widthButton}
              toggleChatApprove={toggleChatApprove}
              styleschat={styleschat}
              displaySmall={threeButtonsDisplayed}
            />
          )}
        </>
      }
      widthButton={widthButton}
      alignButtons={alignButtons}
      isSmallIndex={isSmallIndex}
      heightHoverButton={heightHoverButton}
    />
  )
}

export const ChatHoverButtons = React.memo(_ChatHoverButtons)


const ModPreviewButton = ({
  styleschat,
  id,
  widthButton,
  displaySmall
}: {
  styleschat: ChatStyles
  id: string
  widthButton
  displaySmall: boolean
}) => {
  const setShowPreview = useSetRecoilState(previewAttachmentId)
  const { t } = useTranslation()

  return (
    <Button
      bg={styleschat?.secondaryAccessButtonBackgroundColor ?? "#1AC541"}
      border={
        styleschat?.secondaryAccessButtonBorderColor
          ? `1px solid ${
              styleschat?.secondaryAccessButtonBorderColor
                ? styleschat.secondaryAccessButtonBorderColor
                : "transparent"
            }`
          : "0px"
      }
      textColor={styleschat?.secondaryAccessButtonTextColor ?? "#FFFFFF"}
      _hover={{
        backgroundColor:
          styleschat?.secondaryAccessButtonMouseoverColor ?? "#24A840",
        textColor:
          styleschat?.secondaryAccessButtonTextMouseoverColor ?? "#FFFFFF"
      }}
      type="button"
      fontWeight="bold"
      onClick={() => {
        setShowPreview(id)
      }}
      minWidth={displaySmall ? undefined : widthButton ?? "96px"}
      padding={displaySmall ? ".65rem" : undefined}
      height={displaySmall ? "unset" : undefined}
      fontSize={displaySmall ? "0.6rem" : "0.75rem"}
      _focus={{}}
      zIndex="10000"
      iconSpacing={displaySmall ? ".25rem" : undefined}
      leftIcon={<FaEye />}
    >
      {t("Preview")}
    </Button>
  )
}